import {API_BASE_URL, request} from '@/api';
import {Feed} from '@/api/models/Feeds.ts';
import {Entity, Stub} from '@/api/models/index.ts';
import {Provider} from '@/api/models/Providers.ts';

export interface FeedFile extends Entity {
	path: string,
	name: string | null,
	feed: Stub<Feed>,
	lastModified: Date,
	inactive: boolean,
	provider: Stub<Provider, 'username' | 'state' | 'createdDate'> | null,
}

export interface Preview {
	keys: string[],
	contents: Array<string[]>,
}

export interface IndexResult {
	created: number,
	deleted: number,
	inactive: number,
}

export namespace FeedFiles {
	export async function list(): Promise<FeedFile[]> {
		const files: FeedFile[] = await request('/feeds/files');
		return files.map(denormalize);
	}

	export async function get(id: number): Promise<FeedFile> {
		const file: FeedFile = await request(`/feeds/files/${id}`);
		return denormalize(file);
	}

	export async function update(id: number, data: Partial<FeedFile>): Promise<FeedFile> {
		const file: FeedFile = await request(`/feeds/files/${id}`, {
			method: 'PATCH',
			body: JSON.stringify(data),
		});

		return denormalize(file);
	}

	export function preview(id: number): Promise<Preview> {
		return request(`/feeds/files/${id}/preview`);
	}

	export function index(): Promise<IndexResult> {
		return request('/feeds/files/index', {
			method: 'POST',
		});
	}

	export function getDownloadUrl(file: FeedFile): string {
		return `${API_BASE_URL}/public/feeds/files/${file.id}`;
	}

	function denormalize(file: FeedFile): FeedFile {
		file.lastModified = new Date(file.lastModified);
		return file;
	}
}
